import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'generico-grid-traducciones',
  templateUrl: './grid-traducciones.component.html',
})
export class GridTraduccionesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
